import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LoopIcon from '@material-ui/icons/Loop';
import EventIcon from '@material-ui/icons/Event';
import { useCustomerDetailsStyles } from './CustomerDetails';
import { formatAppointmentTime, getZ3PConfigValue } from '../../helper';
import MenuList from '../../components/MenuList';
import RecurringPlanModal from '../../RecurringAppointments/RecurringPlanModal';
import RescheduleModal from '../../Dispatch/RescheduleModal';

const AppointmentDetails = ({ customer, sw, vehicle }) => {
  const classes = useCustomerDetailsStyles();
  const schedulingSystem = getZ3PConfigValue('scheduling_system');
  const isSkippingVehicle = getZ3PConfigValue('is_skipping_vehicle');
  const isOfferingRecurringAppointments = getZ3PConfigValue(
    'is_offering_recurring_appointments',
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showRecurringModal, setShowRecurringModal] = useState(false);

  const {
    id,
    date,
    customer_address,
    total_taxed_price_dollars,
    services,
    health_check_url,
    hc_is_complete,
  } = sw || {};
  const { multi_line_human_readable_address } = customer_address || {};
  const { display_name: vehicleDisplayName } = vehicle || {};
  const time = formatAppointmentTime(sw);
  const approvedServices = services.filter(
    (s) =>
      s.status !== 'DELETED' &&
      (!s.is_upsell || s.upsell_status === 'approved'),
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid item>
      <IconButton
        onClick={handleClick}
        size="small"
        className={classes.kebabMenu}
      >
        <MoreVertIcon />
      </IconButton>
      <MenuList
        anchorRef={anchorEl}
        handleClose={handleClose}
        classes={classes.listIcon}
      >
        <MenuItem
          component="a"
          href={`/#/scheduled-work/${id}/show`}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View appointment" />
        </MenuItem>
        {schedulingSystem === 'time_slots' && sw.status !== 'cancelled' && (
          <MenuItem
            onClick={() => {
              setShowRescheduleModal(true);
            }}
          >
            <ListItemIcon>
              <EventIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Reschedule" />
          </MenuItem>
        )}
        {health_check_url && hc_is_complete && (
          <MenuItem component="a" href={health_check_url}>
            <ListItemIcon>
              <OpenInNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View service report" />
          </MenuItem>
        )}
        {isOfferingRecurringAppointments && (
          <MenuItem
            onClick={() => {
              setShowRecurringModal(true);
            }}
          >
            <ListItemIcon>
              <LoopIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Create repeat appointments" />
          </MenuItem>
        )}
      </MenuList>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography variant="body2" className={classes.gray}>
                Date
              </Typography>
              <Typography className={classes.fw500}>{date}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" className={classes.gray}>
                Time
              </Typography>
              <Typography className={classes.fw500}>{time}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" className={classes.gray}>
                Address
              </Typography>
              <Typography className={classes.fw500}>
                {multi_line_human_readable_address}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" className={classes.gray}>
                Total Cost
              </Typography>
              <Typography className={classes.fw500}>
                ${total_taxed_price_dollars}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.gray}>
            Services
          </Typography>
          <Typography className={classes.fw500}>
            {approvedServices?.length
              ? approvedServices
                  .map((s) => s.display_name || s.long_name)
                  .join(', ')
              : 'No services scheduled'}
          </Typography>
        </Grid>
        {!isSkippingVehicle && (
          <Grid item xs={12}>
            <Typography variant="body2" className={classes.gray}>
              Vehicle
            </Typography>
            <Typography className={classes.fw500}>
              {vehicle ? vehicleDisplayName : 'No associated vehicle'}
            </Typography>
          </Grid>
        )}
      </Grid>
      {/* Modals */}
      {showRescheduleModal && (
        <RescheduleModal
          open={showRescheduleModal}
          setOpen={setShowRescheduleModal}
          sw={{ ...sw, customer }}
        />
      )}
      {showRecurringModal && (
        <RecurringPlanModal
          customer={customer}
          vehicle={vehicle}
          sw={sw}
          showRecurringModal={showRecurringModal}
          setShowRecurringModal={setShowRecurringModal}
        />
      )}
    </Grid>
  );
};

export default AppointmentDetails;
